<!--  -->
<template>
  <div class="lisnewk">
    <div style="margin-bottom:10px">
      <el-input v-model="objr.account_id" style="width:200px;margin-right:5px" placeholder="请输入推广帐号id" />
      <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="serach">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      <el-button type="warning" icon="el-icon-thumb" @click="authallr">授权</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="account_uin"
        label="推广QQ 号"
        width="150"
        align="center"
      /> -->
      <el-table-column
        prop="account_id"
        label="推广帐号 id"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="推广名称"
        align="center"
      />
      <!-- <el-table-column
        prop="account_role_type"
        label="身份类型"
        width="180"
        align="center"
      />
      <el-table-column
        prop="wechat_account_id"
        label="微信帐号 id"
        width="130"
        align="center"
      />
      <el-table-column
        prop="account_type"
        label="账号类型"
        width="180"
        align="center"
      />
      <el-table-column
        prop="role_type"
        label="角色"
        width="180"
        align="center"
      />
      <el-table-column
        prop="refresh_token_expires_in"
        label="授权token过期时间"
        width="180"
        align="center"
      /> -->
    </el-table>
    <pagination-right
      :current-page="objr.page"
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
    <el-dialog
      title="授权"
      :visible.sync="dialogVisible"
      width="20%"
      @close="anthclose"
    >
      <el-select v-model="account_type" placeholder="请选择授权类型">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div style="margin-top:50px">
        <el-button type="primary" icon="el-icon-thumb" @click="sumbit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { accountindex, builderAuthUrl } from '@/api/behavioral.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      objr: {
        page: 1,
        page_size: 10,
        account_id: null
      },
      total: null,
      tableData: [],
      dialogVisible: false,
      options: [{
        value: 'ACCOUNT_TYPE_QQ',
        label: 'QQ'
      }],
      //  {
      //   value: 'ACCOUNT_TYPE_WECHAT',
      //   label: '微信'
      // // }
      account_type: 'ACCOUNT_TYPE_QQ'
    }
  },
  created() {
    this.serlist()
  },
  mounted() {

  },
  methods: {
    async serlist() {
      const data = await accountindex(this.objr)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    add() {
      this.dialogVisible = true
    },
    fetchPageSizeone(e) {
      this.objr.page_size = e
      this.serlist()
    },
    fetchCurrentPageone(e) {
      this.objr.page = e
      this.serlist()
    },
    serach() {
      this.objr.page = 1
      this.serlist()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.account_id = null
      this.serlist()
    },
    async authallr() {
      this.dialogVisible = true
    },
    async sumbit() {
      if (this.account_type === null) {
        this.$message({
          message: '请选择要授权的类型',
          type: 'error'
        })
        return
      }
      const data = await builderAuthUrl({
        account_type: this.account_type
      })
      window.open(data.data.auth_url, '_blank')
      console.log('data', data)
    },
    anthclose() {
      this.account_type = null
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.lisnewk{
  padding: 20px;
}
.addlinkbox{
  text-align: right;
  margin-bottom: 10px;
}
</style>
